import { FC, useEffect } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Wrapper } from './pages.styled';
import {
  Header,
  Body,
  MobileApp,
  Menu,
  Call,
  MetersResultModal,
  MetersReadingsModal,
  MobileAppModal,
} from '../components';
import { useAppDispatch, useResponsive } from '../../../hooks';
import {
  getPublicRequest,
  savePublicId,
  getPublicRequestAccruals,
  getPublicRequestMeters,
} from '../request-single-page-slice';
import {
  getOnLoadPublicRequestState,
  getShowCallCardState,
} from '../selectors';

export const MainPage: FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const showCallCard = useSelector(getShowCallCardState);
  const { viewport } = useResponsive();
  const onLoadPublicRequest = useSelector(getOnLoadPublicRequestState);

  useEffect(() => {
    if (id) {
      dispatch(savePublicId(id));

      if (!onLoadPublicRequest) {
        dispatch(getPublicRequest(id))
          .then(unwrapResult)
          .then(() => {
            dispatch(getPublicRequestAccruals(id));
            dispatch(getPublicRequestMeters(id));
          })
          .catch(() => {
            history.push('/request_single_page/error/');
          });
      }
    }
  }, [id]);

  return (
    <Wrapper>
      <MetersResultModal />
      <MobileAppModal />
      <MetersReadingsModal />
      {showCallCard && viewport.mobile && <Call />}
      {!viewport.desktop && <MobileApp />}
      <Header />
      {!onLoadPublicRequest && <Menu />}
      <Body />
    </Wrapper>
  );
};
